require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-goodbye-microsoft-band-2-hello-fitbit-surge.json") })
        }
      }, "path---post-goodbye-microsoft-band-2-hello-fitbit-surge");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-goodbye-microsoft-band-2-hello-fitbit-surge!./.cache/json/post-goodbye-microsoft-band-2-hello-fitbit-surge.json
// module id = 325
// module chunks = 231608221292675